import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DatepickerComponent } from '@shared-ikp/components/datepicker/datepicker.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ContractPartnerCompanyForm } from '../../new-contract-partner.utils';
import { buildOrganizationForm } from './organization-form.utils';
import { HelperTextComponent } from '@shared-ikp/components/inputs/helper-text/helper-text/helper-text.component';
import { ContractPartnerType, MeterPointChangeSignalState } from '../../../meterpoint-change-request.types';
import { SignalState } from '@shared-ikp/service/signal-state-service/signal-state.service';
import { maxBirthDate, minBirthDate } from '@shared-ikp/utils/datepicker';

@Component({
  selector: 'ikp-organization-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, DatepickerComponent, TranslatePipe, HelperTextComponent],
  templateUrl: './organization-form.component.html',
})
export class OrganizationFormComponent {
  protected readonly wizardStore: MeterPointChangeSignalState = inject(SignalState);
  protected form: FormGroup;

  constructor() {
    const currentFormState = this.wizardStore.state().newContractPartner.formData?.organizationPartner;
    this.form = buildOrganizationForm(inject(FormBuilder), currentFormState);
  }

  protected isInputInvalid(key: keyof ContractPartnerCompanyForm) {
    return this.form.get(key).touched && this.form.get(key).invalid;
  }

  protected getFormError(key: keyof ContractPartnerCompanyForm): string {
    const formKey = this.form.get(key);
    if (formKey.errors) {
      return formKey.errors.translationKey;
    }
    return null;
  }

  public get validForSubmission(): boolean {
    this.form.markAllAsTouched();
    this.form.updateValueAndValidity();
    const isFormValid = this.form.valid;

    if (isFormValid) {
      this.wizardStore.patchState({
        newContractPartner: {
          ...this.wizardStore.state().newContractPartner,
          emptyPartner: null,
          formData: {
            partnerType: ContractPartnerType.COMPANY,
            organizationPartner: this.form.value,
          },
        },
      });
    }
    return isFormValid;
  }

  protected readonly minBirthDate = minBirthDate;
  protected readonly maxBirthDate = maxBirthDate;
}
